module.exports = __webpack_public_path__ + "img/0499e6_64e8b17b1dc84d68a155f51a93f58eba_mv2.78c94087.webp";